import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=4f5c32c7&scoped=true"
import script from "./Layer.vue?vue&type=script&lang=js"
export * from "./Layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c32c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5c32c7')) {
      api.createRecord('4f5c32c7', component.options)
    } else {
      api.reload('4f5c32c7', component.options)
    }
    module.hot.accept("./Layer.vue?vue&type=template&id=4f5c32c7&scoped=true", function () {
      api.rerender('4f5c32c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/Layer.vue"
export default component.exports